import React from 'react';
import { AuthenticationContext, AuthenticationContextState } from '../context/AuthenticationContext';

const useAuthentication = (): AuthenticationContextState => React.useContext(AuthenticationContext);

export { AuthErrorCodes } from 'firebase/auth';
export default useAuthentication;
